import { Component, EventEmitter, Inject, OnInit} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CombosConfiguration, HttpService, MessageService} from 'brainloper-ui';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Question } from 'src/app/models/inspections/question';
import { GenericResponse } from 'src/app/models/commos/generic-response';


@Component({
    selector: 'app-questions',
    templateUrl: './questions.component.html',
    styleUrls: ['./questions.component.scss'],
    standalone: false
})
export class QuestionsComponent implements OnInit {

  private urlGetComboTipoRespuesta: string = `${EndpointDictionary.PreopResponseType.PREOP_TYPE_RESPONSE_COMBO}`
  private urlPostPregunta: string = `${EndpointDictionary.PreopQuestion.CRUD_PREOP_QUESTION_DATA}`  

  public form: UntypedFormGroup
  private body: Question

  public reloadComboResType = new EventEmitter<any>()
  public combosConfigResType: CombosConfiguration = {
    visibleField: 'responseType',
    selectionField: 'id',
    urlCombo: this.urlGetComboTipoRespuesta,
    urlParams: [],
    label: 'Tipo Respuesta',
    selected: 0
  }

  constructor(
    private message: MessageService,
    private http: HttpService,
    private formBuilder : UntypedFormBuilder,
    public dialogRef: MatDialogRef<QuestionsComponent>,
   @Inject(MAT_DIALOG_DATA) public data:Question,

  ) {
    this.form = this.formBuilder.group({
      responseTypeId:null,
      question:""
      })
  }

  ngOnInit(): void {
    this.message.openLoading('Cargando', 'Cargando información')
    if(this.data){
      this.iniciarCampos()
    }
    this.message.closeLoading()
  }

  iniciarCampos(){
    this.body = this.data
    for (let datos of Object.keys(this.form.controls)) {
      this.form.get(datos).setValue(this.body[datos])
    }
    this.combosConfigResType.selected = this.body.responseTypeId
    this.reloadComboResType.emit("selected")
  }

  ValueResType($event: number){
    if ($event && $event > 0) {
      this.form.get('responseTypeId').setValue($event)
    }
  }
  async save(form: Question){
    this.message.openLoading('Cargando', 'Guardando pregunta')
    if(!this.data){
      try {
        let res: GenericResponse = await this.http.postDataBody(`${this.urlPostPregunta}`, form)
        if(res){
          this.message.closeLoading()
          this.message.SuccessToast(res.message)
          this.dialogRef.close(res.insertId)
        }
      } catch (error) {
        this.message.closeLoading()
        this.message.Error('Error', error)
      }
    }else{
      this.message.closeLoading()
      form.id = this.body.id
      try {
        let res: GenericResponse = await this.http.putDataBody(`${this.urlPostPregunta}`, form)
        if(res){
          this.message.closeLoading()
          this.message.SuccessToast(res.message)
          this.dialogRef.close(form.id)
        }
      } catch (error) {
        this.message.Error('Error', error)
        this.message.closeLoading()
      }
    }

  }
  errorMessage(){
    this.message.Error('Error', 'complete lo campos')
  }

}
